import {
  EngagementType,
  RaffleAdminConfig,
  RaffleAdminData,
  RaffleStatus,
  RaffleTicketFlipDirection,
} from '@/generated/graphql';
import { StageRaffleEngagement } from './stage/stage-view';
import { FanRaffleEngagement } from './fan/fan-view';
import { RaffleEditorView } from './admin/editor-view';
import { AdminRaffleControlView } from './admin/control-view';
import { EngagementDefinition } from '../base/EngagementDefinition';
import { IdCardIcon } from '@radix-ui/react-icons';
import { DEFAULT_RAFFLE_CLAIM_COPY } from './drawing/ticketMotion';

export const raffleEngagementDefinition: EngagementDefinition<
  RaffleAdminConfig,
  RaffleAdminData
> = {
  enabled: true,
  title: 'Raffle',
  Icon: IdCardIcon,
  type: EngagementType.Raffle,
  stageComponent: StageRaffleEngagement,
  fanComponent: FanRaffleEngagement,
  adminEditorView: RaffleEditorView,
  adminControlView: AdminRaffleControlView,
  getInitialData: () => ({
    raffleStatus: RaffleStatus.Open,
    raffleCandidates: [],
    raffleWinners: [],
    raffleWinner: null,
    winnerCount: 1,
    remainingSubmissionIds: [],
    lastEliminatedSubmissionId: null,
  }),
  getInitialConfig: () => ({
    optionalImageUrl: '',
    claimYourPrize: DEFAULT_RAFFLE_CLAIM_COPY,
    ticketFlipDirection: RaffleTicketFlipDirection.AdmitToDrawing,
  }),
};
